import {get} from "../../state/action/apiActions";
import {GET_VERSION} from "../../constant/reducerConstants";


export const getVersion = (dispatch) => {
    return dispatch(get({
        path: "/version",
        requestName: GET_VERSION
    }));
};


// WEBPACK FOOTER //
// ./src/state/action/appActions.js